/**
 * slideshow-elements-fix.js
 * Elaine R4 Launch theme · D1 fix · 27-abr-2026
 *
 * Issue (sesión #073 audit · root cause):
 * Theme R4 utiliza <slideshow-slide>, <slideshow-container>, <slideshow-slides>,
 * <cart-drawer>, <predictive-search>, <localization-form> como web components
 * en el HTML, pero NINGÚN archivo JS los registra como customElements.
 * El navegador los trata como HTMLUnknownElement (display:inline por default),
 * causando que los containers colapsen a 0×0 y el CSS scheme color del block
 * paint un bloque lila vacío sobre las fotos del PDP. Resultado: las fotos
 * existen en el DOM pero quedan ocultas detrás del block colapsado.
 *
 * Fix:
 * Registrar minimal classes (extends HTMLElement) para cada custom tag.
 * Por default los customElements registrados se renderean como block-level,
 * exponen el contenido interno, y el slideshow nativo del theme funciona.
 * NO redefinimos lifecycle methods (connectedCallback, etc.) — solo
 * promovemos el tag de "unknown" a "registered custom element".
 *
 * Side effects:
 * - cart-drawer.js (asset existente) registra <cart-drawer> con su lógica
 *   completa al cargar. Si lo registra primero, este script SKIP (ver el if).
 * - Igual para predictive-search.js, localization-form.js, etc. existentes.
 *
 * Build-on-top discipline:
 * NO toca ningún archivo existente. NO altera ningún element ya registrado.
 * Es un additive shim que solo activa lo que faltaba registrar.
 */
(function () {
  if (typeof customElements === "undefined") return;

  const tags = [
    "slideshow-slide",
    "slideshow-container",
    "slideshow-slides",
    "slideshow-arrows",
    "slideshow-controls",
    "slideshow-arrow",
  ];

  for (const tag of tags) {
    if (!customElements.get(tag)) {
      try {
        customElements.define(tag, class extends HTMLElement {});
      } catch (e) {
        // Race condition: alguien lo definió entre check y define.
        // No-op · skip silently.
      }
    }
  }
})();
